import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { trazContrato } from "../../../services/api-contratos.service";
import Loading from "../../../components/Loading";
import SnackBar from "../../../components/SnackBar";
import styled from "styled-components";
import { buscaConversa } from "../../../services/api-planejamento-tributario.service";
import ChatAssincrono from "../../../components/ChatAssincrono";
import WhiteButton from "../../../components/WhiteButton";
import BlueButton from "../../../components/BlueButton";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import ReenvioDeContrato from "./ReenvioDeContrato";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

const ButtonContact = styled.button`
  all: unset;
  background-color: #ffa500;
  border-radius: 8px;
  color: #fff;
  transition: all 0.2s ease-in-out;
  padding: 10px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    transform: scale(1.1);
  }

  ${(props) =>
    props.newMsg &&
    `
    &::before {
      position: absolute;
      font-size: 0.8rem;
      content: "!";
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 100%;
      background-color: red;
      top: -7px;
      right: -5px;
      text-align: center;
      animation: pulse 1s infinite;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    }
    `}

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const ModalContratos = ({
  handleOpen,
  handleCLose,
  dadosUsuarios,
  closeContract,
}) => {
  const [pdfUrl, setPdfUrl] = useState({ contrato: "", idContrato: null });
  const [loading, setLoading] = useState(false);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [contactButton, setContactButton] = useState({
    label: "Contato",
    newMsg: false,
    title: "Chat de dúvidas",
  });
  const [modalChat, setModalChat] = useState(false);
  const [reenvContrato, setReenvContrato] = useState(false);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        console.log(dadosUsuarios);

        const response = await trazContrato(dadosUsuarios);

        setPdfUrl({
          contrato: response.contrato,
          idContrato: response.idContrato,
        });
        const responseChat = await buscaConversa("JURIDICO", dadosUsuarios.id);

        const typeLastMsg = responseChat.objConversaUsuario.at(-1).tipoContato;
        if (typeLastMsg === "usuario_externo") {
          setContactButton({
            label: "Existem novas mensagens",
            newMsg: true,
            title: "Clique para verificar a mensagem enviada",
          });
        }

        setLoading(false);
      } catch (error) {
        if (!error.status === 404) {
          setObjSnackBar({ type: "error", msg: "Contrato não encontrado" });
          console.log(error);
          setLoading(false);
        }
        setLoading(false);
      }
    };

    if (handleOpen) {
      getData();
    }

    if (handleOpen === false) {
      setContactButton({
        label: "Contato",
        newMsg: false,
        title: "Chat de dúvidas",
      });
    }
  }, [handleOpen]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const contact = urlParams.get("contact");
    const type = urlParams.get("type");

    if (contact && type) {
      setModalChat(true);
    }
  }, [window.location.searc]);

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  const handleCloseModalChat = (value) => {
    setModalChat(value);
  };

  return (
    <>
      <Dialog
        open={handleOpen}
        onClose={() => handleCLose(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          <div className={styles.title}>
            <HistoryEduIcon fontSize="1rem" />
            Contrato
          </div>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <Loading loading={loading} />
          ) : (
            <iframe
              src={pdfUrl.contrato}
              title="Pré-visualização do PDF"
              style={{
                width: "100%",
                height: "60vh",
                border: "none",
                borderRadius: "8px",
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <div className={styles.container_btn}>
            <WhiteButton
              textValue="Fechar"
              clickFunction={() => handleCLose(false)}
            />

            <div className={styles.actions__modalContratos}>
              <ButtonContact
                onClick={() => setModalChat(true)}
                newMsg={contactButton.newMsg}
                title={contactButton.title}
              >
                <ForumOutlinedIcon />
                {contactButton.label}
              </ButtonContact>

              <BlueButton
                contentStartIcon={<SendRoundedIcon />}
                textValue="Atualizar Contrato"
                clickFunction={() => setReenvContrato(true)}
              />
            </div>
          </div>
        </DialogActions>
      </Dialog>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />

      <ChatAssincrono
        handleOpen={modalChat}
        handleCLose={handleCloseModalChat}
        idInteracao="JURIDICO"
        idUsuario={dadosUsuarios.id}
      />

      <ReenvioDeContrato
        modal={reenvContrato}
        setModal={(value) => setReenvContrato(value)}
        dadosUsuario={dadosUsuarios}
        idContrato={pdfUrl.idContrato}
        closePosEnv={() => handleCLose(false)}
      />
    </>
  );
};

export default ModalContratos;
